import script from "./SubastaPestanias.vue?vue&type=script&setup=true&lang=js"
export * from "./SubastaPestanias.vue?vue&type=script&setup=true&lang=js"

import "./SubastaPestanias.vue?vue&type=style&index=0&id=78126d12&lang=css"

const __exports__ = script;

export default __exports__